<script>
  import { onMount } from 'svelte';
  import { get } from 'svelte/store';
  import { asnavigate } from './Utils/asnavigation.js';
  import { useNavigate, useLocation } from 'svelte-navigator';
  const navigate = useNavigate();
  import RouteTransition from './RouteTransition.svelte';
  import { fly, blur } from 'svelte/transition';
  import {
    currentLocation,
    pathTrappe,
    alertReload,
    idTrappe,
    nomTrappe,
    choix,
    dimLongueur,
    dimLargeur,
    sensOuverture,
    fermeture,
    type,
    couleur,
    epaisseur,
    dureeResistance,
    dimLongueurIdFiche,
    dimLargeurIdFiche,
    sensOuvertureIdFiche,
    fermetureIdFiche,
    typeIdFiche,
    couleurIdFiche,
    epaisseurIdFiche,
    dureeResistanceIdFiche,
    coupeFeuIdPath,
    trappePath,
  } from './stores.js';
  import Header from './Components/Header.svelte';
  import Prefooter from './Components/prefooter.svelte';
  import Diagonale from './Components/diagonale.svelte';
  // import Modal from 'svelte-simple-modal';

  import Sidebar from './ComponentsInProcess/SideBar.svelte';
  import SidebarNew from './ComponentsInProcess/SideBar-new.svelte';

  import ChoixTrappe from './Pages/ChoixTrappe.svelte';
  import TitleNNumber from './ComponentsInProcess/TitleNNumber.svelte';
  import BtnInfo from './BtnInfo/BtnInfo.svelte';

  import Metallique1 from './paths/1-metallique.svelte';
  import AluHydro2 from './paths/2-alu-hydro.svelte';
  import VideSanitaire3 from './paths/3-vide-sanitaire.svelte';
  import Etencheite4 from './paths/4-etancheite.svelte';
  import CoupeFeu5 from './paths/5-coupe-feu.svelte';

  import Metallique1Title from './paths/1-mettalique-titles.svelte';
  import AluHydro2Title from './paths/2-alu-hydro-titles.svelte';
  import VideSanitaire3Title from './paths/3-vide-sanitaire-titles.svelte';
  import Etencheite4Title from './paths/4-etancheite-titles.svelte';
  import CoupeFeu5Title from './paths/5-coupe-feu-titles.svelte';

  import BtnFaq from './Faq/BtnFaq.svelte';

  // import MetalliqueReset from './paths/1-metallique-reset-path.svelte';

  import { resetPath } from './resetPath.js';
  import {
    resetTrappeOption,
    getTrappeInSession,
    saveTrappeInSession,
    saveCommande,
  } from './Utils/saveInDb';

  if ($idTrappe.length === 0) {
    console.log(`<!-- ===+++ Trappe options empty +++=== -->`);
    resetTrappeOption();
    pathTrappe.empty();
    asnavigate(navigate, '/LayoutPage');
  }

  // saveSessionTrappe('dac');

  const location = useLocation();

  // export let idTrappe;
  export let idFiche;
  // if (!idFiche) {
  //   $idTrappe = '';
  //   $nomTrappe = '';
  //   $choix = '';
  //   $dimLongueur = '';
  //   $dimLargeur = '';
  //   $sensOuverture = '';
  //   $fermeture = '';
  //   $type = '';
  //   $couleur = '';
  //   $epaisseur = '';
  //   $dureeResistance = '';
  //   $dimLongueurIdFiche = '';
  //   $dimLargeurIdFiche = '';
  //   $sensOuvertureIdFiche = '';
  //   $fermetureIdFiche = '';
  //   $typeIdFiche = '';
  //   $couleurIdFiche = '';
  //   $epaisseurIdFiche = '';
  //   $dureeResistanceIdFiche = '';
  //   $coupeFeuIdPath = '';
  //   $trappePath = [];
  // }

  // if (idFiche == 1) {
  //   $trappePath = [];
  // }
  export let idParam;
  // $: {
  //   resetPath(idFiche);
  //   // console.log(`idParam : ${idParam}`);
  // }
  // console.log(`idTrappe - layoutPage : ${$idTrappe}`);
  // console.log(`idFiche - layoutPage : ${idFiche}`);
  // console.log(`nomTrappe - layoutPage : ${nomTrappe}`);

  $alertReload = true;

  $: {
    $currentLocation = $location.pathname;
    //console.log(`________LayoutPage.svelte________ ${$currentLocation}`);
    pathTrappe.remove($currentLocation);
    // console.log($pathTrappe);
    //console.log(`____________________________`);
    // console.log(`$dimLongueurIdFiche ${$dimLongueurIdFiche}`);
    // console.log(`dimLargeurIdFiche ${$dimLargeurIdFiche}`);
    // console.log(`sensOuvertureIdFiche ${$sensOuvertureIdFiche}`);
    // console.log(`fermetureIdFiche ${$fermetureIdFiche}`);
    // console.log(`typeIdFiche ${$typeIdFiche}`);
    // console.log(`couleurIdFiche ${$couleurIdFiche}`);
    // console.log(`epaisseurIdFiche ${$epaisseurIdFiche}`);
    // console.log(`dureeResistanceIdFiche ${$dureeResistanceIdFiche}`);
    //     let
    // const cars = ["Saab", "Volvo", "BMW"];
    //     for (let i = 0; i < cars.length; i++) {
    //   text += cars[i] + "<br>";
    // }
    // console.log(`----- dimLongueur : ${$dimLongueur}`);
    // console.log(`----- $couleur : ${$couleur}`);
    console.log(`----- Choix : ${$choix}`);
    // if (typeof idParam !== 'undefined') {
  }
</script>

<!-- <Diagonale /> -->
<!-- <Header /> -->

<div class="as-main-section as-container relative mx-auto" style="z-index:10;">
  <!-- <BtnFaq /> -->
  <div class="">
    <div class="container  mx-auto">
      <div class="text-left mt-12"></div>
      <div class="grid grid-cols-6 gap-16 as-grid">
        <div class="col-span-2 ">
          <!-- ===+++ Sidebar +++=== -->
          <!-- <button class="mt-3 mb-3 btn-modal" on:click="{() => openModal()}"> -->
          <SidebarNew idFiche="{idFiche}" idParam="{idParam}" />
        </div>
        <div class="as-col-right col-span-4 mt-20">
          <!-- ===+++ Numbers + titres +++=== -->
          {#if !idFiche}
            <TitleNNumber idFiche="0" />
              <!-- <div
                class="wrapper-faq"
                on:click="{() => {
                  navigate('../../faq');
                }}"
              >
                <div>
                  <div
                    class="as-btn-faq"
                    on:click="{() => {
                      navigate('../../faq');
                    }}"
                  >
                    <svg
                      xmlns="http://www.w3.org/2000/svg"
                      width="40"
                      height="40"
                      preserveAspectRatio="xMidYMid meet"
                      viewBox="0 0 24 24"
                      ><path
                        fill="currentColor"
                        d="M10.6 16q0-2.025.363-2.913q.362-.887 1.537-1.937q1.025-.9 1.562-1.563q.538-.662.538-1.512q0-1.025-.687-1.7Q13.225 5.7 12 5.7q-1.275 0-1.938.775q-.662.775-.937 1.575L6.55 6.95q.525-1.6 1.925-2.775Q9.875 3 12 3q2.625 0 4.038 1.463q1.412 1.462 1.412 3.512q0 1.25-.537 2.138q-.538.887-1.688 2.012Q14 13.3 13.738 13.912q-.263.613-.263 2.088Zm1.4 6q-.825 0-1.412-.587Q10 20.825 10 20q0-.825.588-1.413Q11.175 18 12 18t1.413.587Q14 19.175 14 20q0 .825-.587 1.413Q12.825 22 12 22Z"
                      ></path></svg
                    >
                  </div>
                </div>
            </div> -->
          {:else if $idTrappe == 1}
            <Metallique1Title idFiche="{idFiche}" />
          {:else if $idTrappe == 2}
            <AluHydro2Title idFiche="{idFiche}" />
          {:else if $idTrappe == 3}
            <VideSanitaire3Title idFiche="{idFiche}" />
          {:else if $idTrappe == 4}
            <Etencheite4Title idFiche="{idFiche}" />
          {:else if $idTrappe == 5}
            <CoupeFeu5Title idFiche="{idFiche}" />
          {/if}
          <div class="mt-10 asdesk"></div>
          <!-- ===+++ Frames +++=== -->
          <div class="as-paths">
            <!-- <button on:click="{() => pathTrappe.remove('/LayoutPage/1')}">
              remove mur
            </button>
            <button on:click="{() => pathTrappe.remove($currentLocation)}">
              remove form currentLocation
            </button> -->
            {#if !idFiche}
              <ChoixTrappe />
            {:else if $idTrappe == 1}
              <!-- <MetalliqueReset idFiche="{idFiche}" /> -->
              <Metallique1 idFiche="{idFiche}" />
            {:else if $idTrappe == 2}
              <AluHydro2 idFiche="{idFiche}" />
            {:else if $idTrappe == 3}
              <VideSanitaire3 idFiche="{idFiche}" />
            {:else if $idTrappe == 4}
              <Etencheite4 idFiche="{idFiche}" />
            {:else if $idTrappe == 5}
              <CoupeFeu5 idFiche="{idFiche}" />
            {/if}
          </div>
        </div>
      </div>
    </div>
  </div>
</div>
<Prefooter />

<style>
  .as-col-right {
    min-height: 800px;
  }

  @media only screen and (max-width: 768px) {
    /* .as-main-section {
      margin-bottom: 60px;
      padding-bottom: 80px;
    } */
    .as-main-section {
      padding-bottom: 120px;
      margin-bottom: 20px;
    }
    .as-grid {
      grid-template-columns: none;
      gap: 0;
      margin-top: 30px;
      padding: 0 20px;
    }
    .as-col-right {
      min-height: auto;
      margin-top: 30px;
    }
  }
</style>
